/**
 * Admin control gap #5 ("No staff-level access control inside admin"). There
 * is no real backend admin-user/roles endpoint yet (OIDC only gives us an
 * email — see AdminRoleService), so this is a local, FE-only permission
 * model: a flat `permission: string[]` on the current admin user + a
 * `hasPermission(key)` check, mirroring the exact pattern take-theme uses
 * for merchant staff (`UserPermission` + `SideMenuConfig.permission` +
 * `hasPermission()` in its side-menu component).
 */
export type AdminPermission =
  | '*'
  | 'stores.suspend'
  | 'stores.grantCredits'
  | 'billing.refund'
  | 'features.override'
  | 'moderation.takedown'
  | 'announcements.publish'
  | 'dataRequests.hardDelete'
  | 'mobileApp.edit'
  | 'mobileApp.publish'
  | 'partners.manage'
  | 'partners.payouts'
  | 'partners.settings'

export type AdminRoleKey = 'super_admin' | 'support' | 'finance' | 'ops' | 'read_only'

export interface AdminRoleDefinition {
  key: AdminRoleKey
  label: string
  permissions: AdminPermission[]
}

export const ADMIN_ROLES: AdminRoleDefinition[] = [
  { key: 'super_admin', label: 'adminRoles.role.super_admin', permissions: ['*'] },
  {
    key: 'support',
    label: 'adminRoles.role.support',
    permissions: [],
  },
  {
    key: 'finance',
    label: 'adminRoles.role.finance',
    permissions: ['billing.refund', 'stores.grantCredits', 'partners.payouts', 'partners.settings'],
  },
  {
    key: 'ops',
    label: 'adminRoles.role.ops',
    permissions: [
      'stores.suspend',
      'stores.grantCredits',
      'moderation.takedown',
      'features.override',
      'announcements.publish',
      'mobileApp.edit',
      'mobileApp.publish',
      'partners.manage',
    ],
  },
  {
    key: 'read_only',
    label: 'adminRoles.role.read_only',
    permissions: [],
  },
]
